// site wide alpine stuff
export default () => ({
  mobileNav: false,
  mobileExpanded: false,
  mainHover: false,
  stickyHeader: false,
  header: document.querySelector('header'),
  init() {
    this.isStickyHeader();
    if (this.stickyHeader) {
      this.headerHeight();
    }
    window.addEventListener('resize', (e) => {
      if (this.stickyHeader) {
        this.headerHeight();
      }
    });
    let primaryNav = document.getElementById('primary_navigation');

    if (primaryNav) {
      [...primaryNav.children].forEach((v) => {
        let link = v.querySelector('a');
        let hoverID = v.getAttribute('id');
        link.addEventListener('mouseover', () => {
          this.mainHover = hoverID;
        });
      });
    }

    const observer = new MutationObserver((mutationList) => {
      this.headerObserver(mutationList);
    });
    observer.observe(this.header, {
      attributes: true,
    });
  },
  expandMobile(nav) {
    if (this.mobileExpanded == nav) {
      this.mobileExpanded = false;
    } else {
      this.mobileExpanded = nav;
    }
  },
  isStickyHeader() {
    this.stickyHeader = document
      .querySelector('header')
      .classList.contains('sticky-header');
  },
  headerHeight() {
    let headerHeight = this.header.clientHeight;
    document.body.style.paddingTop = headerHeight + 'px';
  },
  headerObserver(mutationList) {
    mutationList.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class'
      ) {
        this.isStickyHeader();
        if (this.stickyHeader) {
          this.headerHeight();
        }
      }
    });
  },
});
